import Vue from 'vue';
export default Vue.extend({
    props: {
        currentLabel: {
            type: [String, undefined],
            default: undefined
        },
        yAxisKeys: {
            type: Array,
            required: true
        },
        yAxisLabel: {
            type: String,
            required: true
        }
    }
});
